import React from 'react';
import { GrNext, GrPrevious } from 'react-icons/gr';
import Button from '../../shared/buttons/Button';

const CalendarHeader = ({ label, onNavigate }) => (
  <div className="flex justify-center items-center gap-2 ">
    <Button onClick={() => onNavigate('PREV')} variant={'action'} children={<GrPrevious />} />
    <div className="uppercase font-header1 text-xs lg:text-base">{label}</div>
    <Button onClick={() => onNavigate('NEXT')} variant={'action'} children={<GrNext />} />
  </div>
);

export default CalendarHeader;
